<template>
  <Authenticated>
    <div class="store-wrapper">
      <CartColumn @loadOrderLineItem="loadOrderLineItem" :checkoutOpen="openCheckout" />
      <div class="main-container">
        <div v-if="categories.length > 1" class="scroll-buttons">
          <div v-for="(cat, idx) in categories.filter((c) => !c.key.posOnly)" :key="cat.id" class="btn-scroll">
            <div v-if="active_products_in_categories(cat).length > 0" class="catergory-select" @click="catScroll(`${idx}`)">
              <p class="cat-name">{{ cat.key.name }}</p>
            </div>
          </div>
        </div>
        <div v-for="(cat, idx) in categories.filter((c) => !c.key.posOnly)" :key="cat.id">
          <div v-if="active_products_in_categories(cat).length > 0" :id="idx" style="scroll-margin-top: 100px" class="background">
            <h2>{{ cat.key.name }}</h2>
            <span v-if="cat.key.description && cat.key.description !== '<p></p>'" v-html="cat.key.description"></span>

            <ul class="flex-container">
              <router-link
                :to="`/web/${$route.params.id}/${cat.id.replace(/^.*:/, '')}/${prod.id.replace(/^.*:/, '')}`"
                class="long-section"
                v-for="prod in active_products_in_categories(cat)"
                :key="prod">
                <span v-if="prod.value.soldout" class="soldout" @click="productClick(prod.value)">Sold Out</span>
                <li :class="prod.value.soldout ? 'soldoutProd long-layout' : 'active long-layout'" :key="prod.value.id" @click="productClick(prod.value)">
                  <div v-if="prod.value.images">
                    <img loading="lazy" v-if="prod.value.images[0]" :alt="prod.value.name" :src="prod.value.images[0]" />
                    <div v-else class="product-image"></div>
                  </div>
                  <div class="text-center">
                    <h3 class="modifier-name">{{ prod.value.name }}</h3>
                    <p class="caption">{{ prod.value.caption }}</p>
                  </div>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ItemModal :currentProduct="currentProduct" :open="open" :lineItem="lineItem" @closeItemModal="closeItemModal" />
    <DeliveryModal :openDelModal="deliveryAvailable" @close-delivery-modal="closeDeliveryModal" />
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import ItemModal from "@/components/Store/ItemModal";
import { mapGetters, mapActions } from "vuex";
import CartColumn from "./CartColumn.vue";
import DeliveryModal from "./DeliveryModal.vue";

export default {
  name: "app",
  components: {
    Authenticated,
    ItemModal,
    CartColumn,
    DeliveryModal,
  },
  emits: ["handleMenu"],
  computed: {
    ...mapGetters({
      categories: "categories",
      siteSettings: "siteSettings",
      localSettings: "localSettings",
      allProducts: "allProducts",
      active_products_in_categories: "active_products_in_categories",
      cartCount: "cartCount",
      user: "user",
      vuexLoaded: "vuexLoaded",
      getDeliveryHours: "getDeliveryHours",
      socketConnected: "socketConnected",
      getHours: "getHours",
    }),

    portrait() {
      let media = matchMedia("(orientation: portrait)");
      return media.matches;
    },
  },
  data() {
    return {
      openCheckout: false,
      open: false,
      currentProduct: null,
      showHistory: false,
      showCart: true,
      tableMode: false,
      lineItemHash: null,
      lineItem: null,
      show: false,
      change: 0,
      webCart: false,
      showUserModal: false,
      showUserAccountModal: false,
      deliveryAvailable: false,
    };
  },
  async mounted() {
    this.$store.commit("currPage", "store");

    if (this.portrait) {
      window.addEventListener("scroll", this.onScroll);
    } else {
      document.querySelector(".main-container").addEventListener("scroll", this.onScroll);
    }

    if (Object.keys(this.$route.params).length > 0 && Object.keys(this.allProducts).length > 0) {
      this.checkParams();
    }
    await this.$store.dispatch("getAllData");
    if (this.vuexLoaded && this.siteSettings.delivery_settings) {
      this.showDeliveryModal();
    }
  },
  unmounted() {
    if (this.portrait) {
      window.removeEventListener("scroll", this.onScroll);
    } else {
      const main = document.querySelector(".main-container");
      if (main) {
        main.removeEventListener("scroll", this.onScroll);
      }
    }
  },
  methods: {
    ...mapActions(["updateWebOrder"]),

    showDeliveryModal() {
      this.deliveryAvailable = true;
    },

    closeDeliveryModal() {
      this.deliveryAvailable = false;
    },

    onScroll() {
      let position = null;
      let main = document.querySelector(".main-container");
      let buttons = document.querySelector(".scroll-buttons");

      if (!main || !buttons) return;

      if (this.portrait) {
        let documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        position = window.pageYOffset / (documentHeight - window.innerHeight);
      } else {
        position = main.scrollTop / (main.scrollHeight - buttons.clientHeight - main.clientHeight);
      }
      let maxScroll = buttons.scrollWidth - buttons.clientWidth;

      if (maxScroll > 0) {
        let scroll = position * maxScroll;
        buttons.scrollTo({ top: 0, left: scroll, behavior: "instant" });
      }
    },

    topScroll() {
      let media = matchMedia("(orientation: portrait)");
      if (media.matches) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (window.screenY < window.innerHeight) {
          this.webCart = !this.webCart;
        } else {
          this.webCart = true;
        }
      } else {
        this.webCart = !this.webCart;
      }
    },

    catScroll(pos) {
      const cat = document.getElementById(pos);
      if (cat !== null) {
        cat.scrollIntoView({
          behavior: "instant",
          block: "start",
          inline: "nearest",
        });
      }
    },

    closeItemModal() {
      this.lineItem = null;
      this.open = false;
    },

    loadOrderLineItem(lineItem) {
      var product = this.allProducts.find((product) => product.id === lineItem.id);
      this.currentProduct = product.value;

      this.lineItem = lineItem;
      this.open = !this.open;
    },

    productClick(prod) {
      if (!prod.soldout) {
        this.currentProduct = prod;
        this.open = !this.open;
      }
    },

    checkParams() {
      if (this.$route.params.category && this.$route.params.product) {
        let cat = this.categories.find((cat) => cat.id === "category:" + this.$route.params.category);
        let prod = this.active_products_in_categories(cat).find((prod) => prod.value._id === "product:" + this.$route.params.product);
        this.productClick(prod.value);
      }
    },
  },
  watch: {
    open() {
      if (!this.open) {
        this.$router.push({ path: "/web/" + this.$route.params.id });
      }
    },
    allProducts() {
      this.checkParams();
    },

    siteSettings() {
      if (this.vuexLoaded && this.siteSettings.delivery_settings) {
        this.deliveryAvailable = true;
      } else {
        this.deliveryAvailable = false;
      }
    },

    socketConnected() {
      if (this.socketConnected) {
        if (localStorage.getItem("orderID") !== null) {
          this.channel.push("order:status", localStorage.getItem("orderID")).receive("ok", async (reply) => {
            this.updateWebOrder({ order: reply.reply.rows[0].doc });
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.store-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .main-container {
    .soldout {
      font-weight: bold;
      font-size: 1rem;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: var(--text-colour);
      position: absolute;
      border-radius: 0.25rem;
      padding: 0.4rem 0.8rem;
      margin: 0;
      background: var(--warning-colour);
      overflow: hidden;
      z-index: 1;
      text-align: center;
    }

    .soldoutProd {
      opacity: 0.5;
    }

    .background {
      background-color: var(--secondary-colour);
      padding: 1rem;
      margin: 0.5rem 1rem 1rem 1rem;
      border-radius: 0.5rem;

      h2 {
        margin: 0.25rem 0;
        color: var(--text-colour);
      }
      .flex-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
        gap: 1rem;
        padding: 0;
        margin: 0;

        .long-layout {
          position: relative;
          min-height: 12rem;
          display: flex;
          justify-content: space-evenly;
          flex-direction: column;
          align-items: center;
          background-color: var(--primary-colour);
          box-shadow: var(--box-shadow);
          margin: 0.5rem 0;
          padding: 0.5rem;
          text-decoration: none;
          border-radius: 0.25rem;
          cursor: pointer;
          .product-image {
            display: block;
            border: 1px solid var(--primary-colour);
            border-radius: 0.25rem;
          }

          .text-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: smaller;
            .modifier-name {
              margin: 0;
              text-align: center;
            }
            .caption {
              margin: 0.25rem 0;
              justify-content: center;
            }
            .price {
              color: var(--action-colour);
              margin: auto;
            }
          }
        }
      }
    }
    .scroll-buttons {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow-x: auto;
      overflow-y: hidden;
      position: sticky;
      top: 0;
      background-color: var(--primary-colour);
      cursor: pointer;
      z-index: 1000;
      margin: 0rem 1rem 0 1rem;
      white-space: nowrap;
      /* Hide scrollbar but keep functionality */
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE/Edge */

      &::-webkit-scrollbar {
        display: none; /* Chrome/Safari */
      }

      .catergory-select {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 3rem;
        height: 3rem;
        margin: 0.5rem 0.5rem 0.5rem 0rem;
        padding: 0rem 1rem;
        background-color: var(--action-colour);
        color: var(--text-colour);
        border-radius: 0.35rem;

        .cat-name {
          text-align: center;
          padding: 0 0.2rem;
          color: #fff;
        }
      }
    }

    img {
      width: 6rem;
      border-radius: 0.5rem;
      box-shadow: var(--box-shadow);
    }

    .long-section {
      width: 100%;
      position: relative;
      text-decoration: none;
    }
  }
}
@media only screen and (orientation: portrait) {
  .store-wrapper {
    display: block;
    .main-container {
      height: auto;
      .background {
        margin: 0rem 1rem 1rem 1rem;
        .flex-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
          .long-layout {
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            min-height: 6rem;
            margin: 0.15rem 0;
            .text-center {
              align-items: flex-start;
              justify-content: flex-start;
              text-align: left;
              .caption,
              .modifier-name {
                text-align: left;
                margin-left: 1rem;
              }
              .price {
                float: left;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (orientation: landscape) {
  .store-wrapper {
    .cart {
      flex: 2;
    }

    .main {
      flex: 1;
    }
  }
}
</style>
